import { Checkbox, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../utils/i18n.ts';

const CheckboxGroup = Checkbox.Group;

type TypeModalProps = {
  open: boolean;
  selected: number[];
  onClose: () => void;
  onSubmit: (types: number[]) => void;
};

const plainOptions = [
  { value: 1, label: i18n.t('common.specification') },
  { value: 2, label: i18n.t('common.company-agreement') },
  { value: 3, label: i18n.t('common.implementation') },
];

export default function TypeModal({ open, selected, onClose, onSubmit }: TypeModalProps) {
  const [checkedList, setCheckedList] = useState<number[]>(selected);
  const { t } = useTranslation();
  const handleCancel = () => {
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(checkedList);
    onClose();
  };

  const onChange = (list: number[]) => {
    setCheckedList(list);
  };

  return (
    <>
      <Modal
        title={t('common.type-filter')}
        open={open}
        onOk={handleSubmit}
        onCancel={handleCancel}
        cancelText={t('common.cancel')}
        okText={t('common.confirm')}
      >
        <CheckboxGroup
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: '10px',
            padding: '20px 0',
          }}
          options={plainOptions}
          value={checkedList}
          onChange={onChange}
        />
      </Modal>
    </>
  );
}
